// extracted by mini-css-extract-plugin
module.exports = {"gradientContainer":"GradientTransitionSection_gradientContainer__9gkCg","gradient":"GradientTransitionSection_gradient__cDeV0"};